(function() {
    'use strict';
    angular
        .module('emarket.store')
        .directive('emStoreCategories', ['$mdMedia', '$timeout', function($mdMedia, $timeout) {
            var isMobile = !$mdMedia('gt-sm');
            return {
                scope: {
                    sticky: '=',
                    categories: '='
                },
                link: function(scope, element) {
                    scope.state = {
                        visible: false
                    };
                    var watchEvent = scope.$watch(function() {
                        return scope.sticky;
                    },
                    function() {
                        if (scope.sticky && !isMobile) {
                            scope.state.visible = true;
                        } else {
                            scope.state.visible = false;
                        }
                    });

                    var toggle = function() {
                        if (scope.sticky && !isMobile) {
                            return;
                        }
                        $timeout(function() {
                            scope.state.visible = !scope.state.visible;
                        });
                    };
                    var titleElement = angular.element(element[0].querySelector('.store__category__title'));
                    titleElement.on('click', function() {
                        toggle();
                    });

                    scope.$on('$destroy', function() {
                        watchEvent();
                    });
                },
                templateUrl: 'store/store-categories/store-categories.tpl.html'
            };
        }]);
}());
